<script lang="ts" setup>
import { AppFlicker } from '@libs/ui';
</script>

<template>
  <div class="ferry-card-upsell-loading">
    <div v-for="index in 2" :key="index" class="ferry-upsell-loading-item">
      <div class="radio-loader">
        <AppFlicker
          height="spacing-16"
          width="spacing-16"
          border-radius="border-radius-8"
        />
      </div>
      <div class="ticket-loader">
        <AppFlicker
          height="spacing-16"
          width="spacing-96"
          border-radius="border-radius-8"
        />
        <AppFlicker
          height="spacing-16"
          width="spacing-64"
          border-radius="border-radius-8"
        />
      </div>
      <div class="radio-loader">
        <AppFlicker
          height="spacing-16"
          width="spacing-16"
          border-radius="border-radius-8"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ferry-card-upsell-loading {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: 100%;
  justify-content: center;

  .ferry-upsell-loading-item {
    display: flex;
    gap: var(--spacing-12);
    padding: var(--spacing-12);
    align-items: center;
    justify-content: space-between;
    border-radius: var(--border-radius-8);

    .ticket-loader {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      gap: var(--spacing-4);
    }
  }
}
</style>
